import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ApolloLink, InMemoryCache } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { provideApollo } from 'apollo-angular';
import { Kind, OperationTypeNode } from 'graphql';
import { headers } from './graphql.headers';
import { http } from './graphql.http';
import {
  GraphQLRequestInterceptor,
  GraphQLResponseInterceptor
} from './graphql.interceptor';
import { ws } from './graphql.ws';
import { error } from './grapqhl.error';

/**
 * GraphQL Module.
 *
 * @exports
 * @class GraphQLModule
 */
@NgModule({
  imports: [BrowserModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GraphQLRequestInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GraphQLResponseInterceptor,
      multi: true
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideApollo(() => {
      /**
       * @description Link.
       * @returns {ApolloLink}
       */
      const link = (): ApolloLink =>
        ApolloLink.from([
          headers(),
          error(),
          ApolloLink.split(
            ({ query }) => {
              const definition = getMainDefinition(query);
              return (
                definition.kind === Kind.OPERATION_DEFINITION &&
                definition.operation === OperationTypeNode.SUBSCRIPTION
              );
            },
            ws(),
            http()
          )
        ]);

      return {
        link: link(),
        cache: new InMemoryCache(),
        defaultOptions: {
          query: { fetchPolicy: 'no-cache' },
          mutate: { fetchPolicy: 'no-cache' },
          watchQuery: { fetchPolicy: 'cache-and-network' }
        }
      };
    })
  ]
})
export class GraphQLModule {}
